'use strict';

angular.module('openDataApp')
  .controller('MainCtrl', ['$scope', '$rootScope', '$state', '$q', '$cookies', 'ContentProvider', 'AuthService', 'ApiService',
                  function ($scope, $rootScope, $state, $q, $cookies, ContentProvider, AuthService, ApiService) {

    $scope.currentService = ContentProvider.currentService;
    $scope.showcase = ContentProvider.main.showcase;
    $scope.activeTab = 0;
    $scope.setActiveTab = function (i) {
      $scope.activeTab = i;
    };
    $scope.content = ContentProvider;

    var host = window.location.host.replace('www.', ''),
        hostname = window.location.hostname.replace('www.', ''),
        splitHost = host.split('.');

    if (splitHost.length === 2) {
      $scope.subdomain = '';
      $scope.host = host;
    } else {
      $scope.subdomain = splitHost[0];
      $scope.host = host.replace(/^[^.]+\./g, "");
    }

    var service = 'main';
    if ($scope.subdomain === 'openiban') {
      service = 'iban';
    } else if (host.split('.')[0] === 'openiban') {
      service = 'iban';
      $scope.host = 'siteworkers.nl';
    } else if ($scope.subdomain === 'openpostcode') {
      service = 'postal';
    } else if ($scope.subdomain === 'openkvk') {
      service = 'kvk';
    } else if ($state.current.name === 'dashboard') {
      service = 'dashboard';
    }
    $scope.currentService = ContentProvider[service];

    $rootScope.loggedIn = AuthService.isAuthenticated();

    var getPlans = function () {
      var plans = $cookies.get('plans');
      if (plans === undefined || plans === null) {
        ApiService.getPlans()
          .then(
            function success(response) {
              $scope.staticData = response.data;
              $cookies.put('plans', JSON.stringify(response.data), { path: '/', domain: '.' + (hostname.split('.').length === 2 ? hostname : hostname.replace(/^[^.]+\./g, ""))});
            },
            function error() {
              return { failed: true };
            }
          );
        return { pending: true };
      } else {
        return JSON.parse(plans);
      }
    };
    $scope.staticData = getPlans();
    $scope.timespans = [{ length: 1 }, { length: 3 }, { length: 6, freeMonths: 1 }, { length: 12, freeMonths: 2 }];

    $scope.resetRequest = false;

    $scope.prefs = {
      codeLanguage: $cookies.get('codeLanguage') || 'curl'
    };
    var saveCodeLanguage = function(newVal) {
      $cookies.put('codeLanguage', newVal);
    };
    $scope.$watch('prefs.codeLanguage', saveCodeLanguage);
  }]);
